import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { INVENTORY_SECURITY_DAY_BASE_PATH } from '../../../../../../../../../features/inventory/security-day/inventory-security-day-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'inventory-balances',
        label: 'Inventory',
        to: INVENTORY_SECURITY_DAY_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
